<template>
  <v-layout column justify-center align-center>
    <v-avatar
      size="128"
      color="grey lighten-4"
    >
      <img
        v-if="user.avatar.url !== null"
        :src="user.avatar.url"
        :alt="`Avatar de ${user.reduced_name}`"
      />
      <span class="headline" v-else>{{ acronym(user.name) }}</span>
      <v-progress-circular
        v-if="loading.show && loading.component === 'UserAvatar'"
        indeterminate
        :width="2"
      />
    </v-avatar>
  </v-layout>
</template>

<script>
import UploadAvatar from '@/components/account/avatar/UploadAvatar';
import acronym from '@/utils/acronym';

export default {
  name: 'UserAvatar',
  components: {
    UploadAvatar,
  },
  methods: {
    acronym,
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/account/avatar/UserAvatar.vue